import { Modal, ModalBody, Flex } from '@chakra-ui/react';
import { useConnectModal } from '@rainbow-me/rainbowkit';

import {
  CustomModalOverlay,
  CustomModalContent,
  CustomModalHeader,
} from './Modal';
import { CustomConnectWalletButton } from './WalletDropDown';

type ModalType = {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  width?: string;
  size?: string;
  connectCb?: () => void;
};

const ConnectWalletModal = ({
  title,
  isOpen,
  onClose,
  width,
  size,
  connectCb,
}: ModalType) => {
  const { openConnectModal } = useConnectModal();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      isCentered
      size={size}
    >
      <CustomModalOverlay />
      <CustomModalContent width={width} zIndex={1}>
        <CustomModalHeader textTransform={'uppercase'}>
          {title}
        </CustomModalHeader>
        <ModalBody width={width}>
          <Flex
            w="100%"
            h={'10.5rem'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <CustomConnectWalletButton
              openConnectModal={() => {
                connectCb?.();
                openConnectModal!();
              }}
              hasImage={false}
              text="Connect Your Wallet"
            />
          </Flex>
        </ModalBody>
      </CustomModalContent>
    </Modal>
  );
};

export default ConnectWalletModal;
